import {ApolloClient, InMemoryCache} from '@apollo/client';

export const client = new ApolloClient({
  uri: `${process.env.GATSBY_WEBSITE_URL}graphql`,
  cache: new InMemoryCache(),
});
